import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';

import { RegisterService } from 'src/app/shared/services/register.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  private readonly notifier: NotifierService;
  resetPassForm: FormGroup;
  tenant: string = '';
  public loading: boolean;

  get email(): string {
    return this.resetPassForm.value.email;
  }

  get resetPassFormControl() {
    return this.resetPassForm.controls;
  }


  constructor(
    private readonly fb: FormBuilder,
    private readonly registerService: RegisterService,
    notifierService: NotifierService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    this.notifier = notifierService;
    this.resetPassForm = fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
  }

  sendResetEmail() {
    this.loading = true;
    this.registerService.emailResetPassword(this.email, true).subscribe({
      next: (resetResult) => {
        this.notifier.notify('success', 'Verifique seu e-mail e caixa de spam.');
        this.loading = false;
        this.router.navigate([`${this.tenant}/admin/login`]);
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  goBack() {
    this.router.navigate([`${this.tenant}/admin/login`]);
  }
}
